import produce from 'immer';
import initialState from '../initialState/customFonts';
import * as customFontsActionTypes from '../../constants/actionTypes/customFonts';

const customFonts = (state = initialState, action) =>
    produce(state, (draftState) => {
        if (action.type === customFontsActionTypes.UPDATE_CUSTOM_FONTS) {
            draftState.data[action.payload.fontFamilyID] = action.payload.fontFamilyData;
        } else if (action.type === customFontsActionTypes.SET_LOADED_STATUS) {
            draftState.isLoaded = action.payload;
        } else if (action.type === customFontsActionTypes.SET_INFO_LOADED_STATUS) {
            draftState.isInfoLoaded = action.payload;
        }
    });

export default customFonts;
